export const banksDefault: any[] = [
    {value: 237, label: '237 - BANCO BRADESCO S.A.'},
    {value: 1, label: '001 - BANCO DO BRASIL S.A.'},
    {value: 341, label: '341 - BANCO ITAU S.A.'},
    {value: 33, label: '033 - BANCO SANTANDER BRASIL S.A.'},
    {value: 104, label: '104 - CAIXA ECONOMICA FEDERAL'},
    {value: 260, label: '260 - NU PAGAMENTOS S.A.'},
]